import { Component, OnInit, Input } from '@angular/core';
import { IWizardContentComponent } from '../../../wizard.content';

@Component({
  selector: 'update-user-password-results',
  templateUrl: './update-user-password-results.component.html',
  styleUrls: ['./update-user-password-results.component.scss']
})
export class UpdateUserPasswordResultsComponent implements IWizardContentComponent {
  
  @Input() step: any;
  @Input() subStep: any;
  @Input() wizardCtrl: any;
  @Input() id: string;
  @Input() previousOutput: any;

  constructor() { }

  requestFailed() {
    return this.wizardCtrl.getWizardService().requestFailed;
  }

  returnErrorMessage() {
    return this.wizardCtrl.getWizardService().errorMessage;
  }

  get errorCauseMessage() {
    return this.wizardCtrl.getWizardService().errorDescription;
  }

  returnSuccessMessage() {
    return this.wizardCtrl.getWizardService().successMessage;
  }

}
